module.exports = __webpack_public_path__ + "media/images/flavours/icon-empyreumatique_dark-698b552048e33d9f1ca3c6ad6a73f31e.png";